module.exports = __webpack_public_path__ + "static/media/settings.47098cbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/settings.svg
// module id = 918
// module chunks = 53